import { Box, Button, Input, Text } from "@chakra-ui/react";
import { UseFormReturnType } from "@mantine/form";
import React from "react";
import { Link } from "react-router-dom";
import { EmailType } from "../../pages/auth/forgot_password";
import Form from '../custom/Form'
import Logo from '../../components/brand/Logo'

const style = {
  backgroundColor: '#313338',
  width: '100%',
  borderRadius: 15,
  paddingTop: 35,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 90,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
}

interface Props {
  handleForgotPassword: (values: EmailType) => void,
  forgotPasswordForm: UseFormReturnType<{ email: string }>,
  isLoading: {
    forgotPassword: boolean;
    resetPassword: boolean;
    otp: boolean;
    resendOtp: boolean;
  }
}

const ForgotPasswordForm: React.FC<Props> = ({
   handleForgotPassword,
   forgotPasswordForm,
   isLoading
 }) => {
  return (
    <Form 
      style={style} 
      onSubmit={forgotPasswordForm.onSubmit((values) => handleForgotPassword(values))}
    >
      <Box w="100%" px={[3, 10]}>
        <Box
          textAlign='center'
          fontWeight='bold'
          fontSize={['xl']}
        >
          <Logo color='#B5BAC1' />

          <Text color='#B5BAC1' mt={8}>
            Forgot Password?
          </Text>

          <Text fontWeight='light' fontSize="md" color='#B5BAC1' mt={4}>
            Enter your email address and a OTP will be sent to you 
          </Text>
        </Box>

        <Box mt={5} w="100%">
          <Box>
            <Text fontWeight='semibold' color='#B5BAC1'>
              Email
            </Text>

            <Input
              {...forgotPasswordForm.getInputProps('email')}
              disabled={isLoading.forgotPassword}
              bgColor='#1E1F22' size='lg' mt={1}
              placeholder="admin@admin.com"
              _placeholder={{ color: '#B5BAC1' }}
              color='#B5BAC1'
              border={forgotPasswordForm.errors.email ? '2px' : '0px'}
              borderColor={forgotPasswordForm.errors.email ? 'red.500' : 'transparent'}
              focusBorderColor={forgotPasswordForm.errors.email ? 'red.500' : 'transparent'} 
              _hover={{ outlineColor: 'transparent' }}
            />

            {forgotPasswordForm.errors.email &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {forgotPasswordForm.errors.email}
              </Text>
            }
          </Box>

          {!isLoading.forgotPassword  &&
            <Box style={{ width: "fit-content" }} mt={5}>
              <Link to='/signin'>
                <Text _hover={{ textDecoration: "underline" }} w='fit-content' fontWeight='light' fontSize='sm' color='#B5BAC1'>
                  I remember now. Go back!
                </Text>
              </Link>
            </Box>
          }

          <Box mt={5}>
            <Button
              type="submit"
              isLoading={isLoading.forgotPassword}
              bg='#37A75B' size="lg"
              w='100%' color='white'
              _hover={{ backgroundColor: '#046425' }
              }>
              Send reset OTP
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

export default ForgotPasswordForm